import React, { useState, useEffect, useMemo } from 'react';
import Pagination from '@mui/material/Pagination';

interface IAdminTeamViewList {
  handleResend: any;
  handleRevoke: any;
  pendingList: any;
}

const AdminTeamViewList: React.FC<IAdminTeamViewList> = ({
  pendingList,
  handleResend,
  handleRevoke,
}) => {
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState<number>(1);
  const resultsPerPage = 15;

  const pageItems = useMemo(() => {
    const start = page * resultsPerPage;
    return pendingList.slice(start, start + resultsPerPage);
  }, [pendingList, page]);

  const handlePageChange = (e: any, new_page: number) => {
    const handledPage = new_page - 1;
    setPage(handledPage);
  };

  useEffect(() => {
    const totalPages = Math.ceil(pendingList.length / resultsPerPage);
    if (totalPages >= 200) {
      setPageCount(199);
    } else if (totalPages <= 199) {
      setPageCount(totalPages);
    }
  }, [pendingList]);

  useEffect(() => {
    setPage(0);
  }, [pendingList]);

  return (
    <>
      {pageItems.map((item: any, index: number) => (
        <div className='team-table-member-row' key={index}>
          <div className={'team-table-row-name'}>
            <div className='team-table-row-text'>{''}</div>
          </div>
          <div className={'team-table-row-name'}>
            <div className='team-table-row-text'>{item.email}</div>
          </div>
          <div className={'team-table-row-perms'}>
            <div className='team-table-row-text'>
              {item.preassigned_license_type.charAt(0).toUpperCase() +
                item.preassigned_license_type.slice(1)}
            </div>
          </div>
          <div className={'team-table-row-placeholder'}>
            <div
              className='team-table-row-placeholder-btn'
              onClick={() => handleResend(item.email)}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='19'
                viewBox='0 0 24 19'
                fill='none'
              >
                <path
                  d='M15.7927 16.0926C15.7927 16.0926 15.5913 14.7839 15.5913 13.8874C15.5913 12.991 15.9392 12.0946 16.644 11.4044C18.0444 10.0329 20.3053 10.0329 21.7057 11.4044C23.1062 12.7759 23.1062 14.99 21.7057 16.3615C20.5524 17.491 18.8041 17.6882 17.4495 16.9532M14.1176 14.4342L15.8019 16.0837L17.4861 14.4342'
                  stroke='var(--card-text)'
                  strokeWidth='1.3'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M11.8099 13.6809H4.9079C3.54052 13.6809 2.8487 13.6809 2.42546 13.4755C2.16501 13.3491 1.93711 13.1675 1.76619 12.9463L7.02408 8.33333L7.49614 8.65719C8.12286 9.08373 8.4647 9.3128 8.90421 9.41548C9.28675 9.51027 9.70185 9.51027 10.0844 9.41548C10.5239 9.3128 10.8657 9.07583 11.5006 8.64929L11.9564 8.34123L13.2098 9.43918C13.511 9.10742 13.8447 8.80727 14.2191 8.5466L13.104 7.56714L17.6375 4.48657V7.50395C18.1096 7.50395 18.5572 7.56714 18.9967 7.67772V4.76303C18.9967 4.21011 18.9967 3.75197 18.9805 3.36493C19.013 3.24645 19.0049 3.12006 18.956 2.99368C18.9154 2.49605 18.8258 2.109 18.6305 1.75355C18.3131 1.14534 17.8084 0.655608 17.1736 0.347551C16.4655 0 15.6678 0 14.0807 0H4.9079C3.32077 0 2.52313 2.35405e-08 1.81503 0.35545C1.18831 0.671406 0.683687 1.15324 0.358122 1.76935C0.170922 2.1248 0.0813914 2.51185 0.0406957 3.00948C0 3.12796 -0.00813914 3.25434 0.0162783 3.38073C0 3.75197 0 4.20221 0 4.75513V10.2291C0 11.7773 0 12.5513 0.358122 13.2385C0.675548 13.8468 1.18017 14.3365 1.80689 14.6445C2.51499 15 3.31263 15 4.89976 15H12.111C11.9564 14.5814 11.8506 14.139 11.8017 13.6809H11.8099ZM1.57085 2.35387C1.75805 1.99052 2.0592 1.70616 2.4336 1.51659C2.85684 1.31122 3.54052 1.31122 4.91604 1.31122H14.0888C15.4562 1.31122 16.148 1.31122 16.5713 1.51659C16.9457 1.69826 17.2387 1.99052 17.434 2.35387C17.5154 2.50395 17.5643 2.68562 17.5887 2.91469L11.6634 6.94313C11.6634 6.94313 11.6308 6.96682 11.6145 6.97472L10.7274 7.57504C10.239 7.90679 9.9623 8.08847 9.7751 8.13586C9.60418 8.17535 9.41698 8.17535 9.24606 8.13586C9.05072 8.08847 8.78213 7.90679 8.2775 7.56714L7.39034 6.96682C7.39034 6.96682 7.37406 6.95103 7.35778 6.95103L1.41621 2.91469C1.44877 2.67773 1.4976 2.49605 1.57085 2.35387ZM1.35924 10.237V4.48657L5.89273 7.56714L1.36737 11.5245C1.3511 11.1848 1.3511 10.7583 1.3511 10.237H1.35924Z'
                  fill='#BEBEC1'
                />
              </svg>
            </div>
            <div
              className='team-table-row-placeholder-btn'
              onClick={() => handleRevoke(item.email)}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                viewBox='0 0 20 20'
                fill='none'
              >
                <path
                  d='M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167'
                  stroke='var(--card-text)'
                  strokeWidth='1.66667'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </div>
          </div>
        </div>
      ))}
      <div className='screening-results-footer'>
        <div className='screening-results-pagination-text'>
          Page {page + 1} of {pageCount}
        </div>
        <div className='screening-results-footer-action-group'>
          <div className='hb-pagination'>
            <Pagination
              onChange={handlePageChange}
              size='large'
              count={pageCount}
              shape='rounded'
              variant='text'
              page={page + 1}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminTeamViewList;
